<template>
    <div class="main-container">
        <div class="main-page">
            <div class="main-page__left">
                <main-menu></main-menu>
            </div>
            <div class="main-page__right">
                <div class="">
                    <div class="choosing-arenas">
                        <h2 class="main-title">
                            Choose arena for edit
                            <span v-if="chosenArena">or</span>
                            <span class="create-arena-link" v-if="chosenArena" @click="showCreateForm">Create new</span>
                        </h2>
                        <ChoseArenaForm
                            class="choosing-arenas"
                            :arenas="arenas"
                            :areArenasLoading="areArenasLoading"
                            v-on:choseArena="onChooseArena"
                        ></ChoseArenaForm>
                    </div>
                </div>

                <Loader v-if="isDataLoadInProgress"></Loader>



                <div v-else class="arena-form">

                    
                    <div v-if="chosenArena && chosenArena.data && chosenArena.meta">

                        
                        <div class="default-tabs-container">
                            <v-btn icon small class="tabs-scroll tabs-scroll--left" @click="scrollTabs(-220)" title="Scroll left">
                                <v-icon small>mdi-chevron-left</v-icon>
                            </v-btn>
                            <Tabs
                                ref="tabsComp"
                                :tabs="tabs"
                                :currentTab="currentTab"
                                :wrapper-class="'default-tabs'"
                                :tab-class="'default-tabs__item'"
                                :tab-active-class="'default-tabs__item_active'"
                                :line-class="'default-tabs__active-line'"
                                @onClick="onTabClick"
                            />
                            <v-btn icon small class="tabs-scroll tabs-scroll--right" @click="scrollTabs(220)" title="Scroll right">
                                <v-icon small>mdi-chevron-right</v-icon>
                            </v-btn>
                        </div>

                        <div class="tab-content">
                            <div v-show="currentTab === 'tab1'">
                                <EditForm
                                    :chosenArenaMeta="chosenArena.meta"
                                    :chosenArena="chosenArena.data"
                                    :partners="partners"
                                    :locales="locales"
                                    :feeds="feeds"
                                    :sortings="sortings"
                                    :nestEnvironments="nestEnvironments"
                                ></EditForm>
                            </div>

                            <div v-show="currentTab === 'tab2'">
                                <ArenaTextEditForm
                                    :selectedArena="chosenArena.data"
                                    :globalTextAllLocales="globalText"
                                ></ArenaTextEditForm>
                            </div>
                            <div v-show="currentTab === 'tab3'">
                                <PushNotificationsTab :selectedArena="chosenArena.data"></PushNotificationsTab>
                            </div>
                            <div v-show="currentTab === 'tab4'">
                                <ScriptEditForm :selectedArena="chosenArena.data"></ScriptEditForm>
                            </div>
                            <div v-show="currentTab === 'tab5'">
                                <RedirectsEditForm :selectedArena="chosenArena.data"></RedirectsEditForm>
                            </div>
                            <div v-show="currentTab === 'tab6'">
                                <ABTestsForm
                                    v-bind:chosenArena="chosenArena.data"
                                    :formSchema="formSchema"
                                ></ABTestsForm>
                            </div>
                            <div v-show="currentTab === 'tab7'">
                                <ChangeLayoutForm :selectedArena="chosenArena.data"></ChangeLayoutForm>
                            </div>
                            <div v-show="currentTab === 'tab8'">
                                <ManageCategories :selectedArena="chosenArena.data" />
                            </div>
                            <div v-if="chosenArena">
                                <clear-cache-btn :selectedArena="this.chosenArena.data"></clear-cache-btn>
                            </div>
                        </div>
                    </div>

                    <CreateForm
                        v-else
                        v-on:arena-created="getCreatedArenas"
                        :arenas="arenas"
                        :partners="partners"
                        :locales="locales"
                        :feeds="feeds"
                        :sortings="sortings"
                    ></CreateForm>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Tabs from 'vue-tabs-with-active-line';
import CreateForm from '../CreateForm/CreateForm.vue';
import EditForm from '../EditForm/EditForm.vue';
import ABTestsForm from '../ABTests/ABTests.vue';
import ArenaTextEditForm from '../ArenaTextEditForm/ArenaTextEditForm.vue';
import Loader from '../../Loader/Loader.vue';
import config from '../../../config';
import { locales } from '../../../constants/locales';
import MainMenu from '../../MainMenu/MainMenu.vue';
import ChoseArenaForm from '../ArenasList/ChoseArenaForm.vue';
import ClearCacheBtn from '../../ClearCacheBtn/ClearCacheBtn.vue';
import PushNotificationsTab from '../PushNotificationsTab/PushNotificationsTab.vue';
import ScriptEditForm from '../3rdPartyScripts/3rdPartyScriptsPage.vue';
import RedirectsEditForm from '../Redirects/RedirectsPage.vue';
import ChangeLayoutForm from '../ChangeLayoutForm/ChangeLayoutForm.vue';
import ManageCategories from '../ManageCategories/ManageCategories.vue';
import { nestEnvironments } from '@/constants/nestEnvironments';

import _isEqual from 'lodash.isequal';
import jsonPointer from 'json-pointer';
import jsonSchemaWalker from '@cloudflare/json-schema-walker';
import $RefParser from '@apidevtools/json-schema-ref-parser';

// const _isEqual = require('lodash.isequal');
// const jsonPointer = require('json-pointer');
// const jsonSchemaWalker = require('@cloudflare/json-schema-walker');
// const $RefParser = require('@apidevtools/json-schema-ref-parser');
const options = {};

export default {
    components: {
        ManageCategories,
        RedirectsEditForm,
        ScriptEditForm,
        PushNotificationsTab,
        ClearCacheBtn,
        ChoseArenaForm,
        MainMenu,
        CreateForm,
        EditForm,
        ABTestsForm,
        ArenaTextEditForm,
        Loader,
        Tabs,
        ChangeLayoutForm,
    },
    name: 'MainPage',
    data() {
        return {
            currentTab: 'tab1',
            chosenArena: null,
            feeds: [],
            sortings: [],
            globalText: null,
            locales: locales,
            isDataLoadInProgress: false,
            arenas: [],
            partners: [],
            areArenasLoading: false,
            isArenaLoading: false,
            formSchema: null,
            categoriesSchema: null,
            nestEnvironments: nestEnvironments,
            tabs: [
                {
                    title: 'Settings',
                    value: 'tab1',
                },
                {
                    title: 'Arena Texts',
                    value: 'tab2',
                },
                {
                    title: 'Push Notifications',
                    value: 'tab3',
                },
                {
                    title: '3rd Party Scripts',
                    value: 'tab4',
                },
                {
                    title: 'Redirects',
                    value: 'tab5',
                },
                {
                    title: 'AB Tests',
                    value: 'tab6',
                },
                { title: 'Layout', value: 'tab7' },
                { title: 'Categories', value: 'tab8' },
            ],
        };
    },
    async created() {
        // Ensure authentication before loading data
        try {
            await this.$msal.ensureAuthenticated();
            this.getData();
        } catch (error) {
            console.error('Authentication failed:', error);
        }
    },
    methods: {
        scrollTabs (delta) {
            try {
                const rootEl = this.$refs.tabsComp && this.$refs.tabsComp.$el
                const scroller = rootEl && rootEl.querySelector('.default-tabs')
                if (scroller) {
                    scroller.scrollBy({ left: delta, behavior: 'smooth' })
                }
            } catch (e) {
                // no-op
            }
        },
        showCreateForm: function () {
            this.chosenArena = null;
        },
        onChooseArena: function (arena) {
            this.chosenArena = arena;
            this.currentTab = 'tab1';
            this.isDataLoadInProgress = false;
        },
        getCreatedArenas: async function () {
            await this.getArenas();
        },
        getData: function () {
            this.isDataLoadInProgress = true;

            let feedPromise = this.$gameApi.get(`/feeds`).catch(error => {
                console.error('Error loading feeds:', error);
                return [];
            });
            let sortingPromise = this.$http.get(`${config.apiUrl}/sorting/list`).catch(error => {
                console.error('Error loading sortings:', error);
                return { body: [] };
            });
            let globalTextPromise = this.$http.get(`${config.apiUrl}/arena/text/get`).catch(error => {
                console.error('Error loading global text:', error);
                return { body: null };
            });
            let formSchema = this.$http.get(`${config.arenaUrl}/schema.json`).catch(error => {
                console.error('Error loading form schema:', error);
                return { body: { definitions: { ABTestsSettings: null } } };
            });
            // let categoriesSchema = this.$http.get(`${config.apiUrl}/arena/search/get-categories-schema`)

            Promise.all([
                feedPromise,
                sortingPromise,
                globalTextPromise,
                formSchema,
                // categoriesSchema,
                this.getArenas(),
                this.getPartners(),
            ]).then(
                ([feedResponse, sortingResponse, globalTextResponse, formSchema /*, categoriesSchema */]) => {
                    // Ensure feeds is an array
                    if (Array.isArray(feedResponse)) {
                        this.feeds = feedResponse.concat([{ id: 0, name: '# Use Blob Feed', environment: 'Old' }]);
                    } else {
                        console.error('Feeds response is not an array:', feedResponse);
                        this.feeds = [{ id: 0, name: '# Use Blob Feed', environment: 'Old' }];
                    }
                    
                    // Ensure sortings is an array
                    if (sortingResponse && sortingResponse.body && Array.isArray(sortingResponse.body)) {
                        this.sortings = sortingResponse.body;
                    } else {
                        console.error('Sortings response is not an array:', sortingResponse);
                        this.sortings = [];
                    }
                    
                    this.globalText = globalTextResponse.body;
                    this.formSchema = formSchema.body.definitions.ABTestsSettings;
                    this.isDataLoadInProgress = false;
                },
                (error) => {
                    console.log(error);
                    this.isDataLoadInProgress = false;
                }
            );
        },
        onTabClick(newTab) {
            this.currentTab = newTab;
        },
        getPartners: function () {
            return this.$http.get(`${config.apiUrl}/partners/model/list`).then(
                (response) => {
                    this.partners = response.body;
                },
                (error) => {
                    console.log(error);
                }
            );
        },
        getArenas: function () {
            this.areArenasLoading = true;
            return this.$http.get(`${config.apiUrl}/arena/table-model/list`).then(
                (response) => {
                    this.arenas = response.body;
                    this.areArenasLoading = false;
                    
                    // Check if we need to search for a domain after arenas load
                    this.checkForDomainSearch();
                },
                (error) => {
                    console.log(error);
                    this.areArenasLoading = false;
                }
            );
        },
        checkForDomainSearch: function () {
            const searchDomain = sessionStorage.getItem('searchArenaDomain');
            
            if (searchDomain) {
                sessionStorage.removeItem('searchArenaDomain');
                
                // Wait for page to be fully loaded and then search
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.findArenaByDomain(searchDomain);
                    }, 500);
                });
            }
        },
        findArenaByDomain: function (domain) {
            // Search in the loaded arenas first (this is the same data that ChoseArenaForm uses)
            const foundArena = this.findArenaInTree(this.arenas, domain);
            if (foundArena) {
                // Use the same approach as ArenasTreeItem.getArena() - make API call to get full data
                this.$http.get(`${config.apiUrl}/arena/get?domain=${domain}`).then(
                    (response) => {
                        const arenaData = response.body;
                        if (arenaData) {
                            // Create arena object in the same format as ArenasTreeItem.getArena()
                            const finalArena = {
                                meta: foundArena.meta,  // Use the meta from loaded list
                                data: arenaData         // Use the full data from API
                            };
                            
                            // Set the chosen arena to show the edit form
                            this.onChooseArena(finalArena);
                        } else {
                            this.showArenaNotFoundError(domain);
                        }
                    },
                    (error) => {
                        console.error('Error getting full arena data:', error);
                        this.showArenaNotFoundError(domain);
                    }
                );
                return;
            }
            
            this.showArenaNotFoundError(domain);
        },
                findArenaInTree: function (arenas, domain) {
            if (!arenas || !Array.isArray(arenas)) {
                return null;
            }
            
            for (let arena of arenas) {
                if (arena.domain === domain) {
                    // Create arena object with proper structure
                    return {
                        meta: arena,
                        data: arena  // This will be replaced with full API data in findArenaByDomain
                    };
                }
                if (arena.children && arena.children.length > 0) {
                    const found = this.findArenaInTree(arena.children, domain);
                    if (found) return found;
                }
            }
            return null;
        },
        showArenaNotFoundError: function (domain) {
            this.$swal.fire({
                icon: 'error',
                title: 'Arena not found',
                text: `Could not find arena for domain: ${domain}. Please check the domain name or create a new arena.`,
                timer: 5000,
                showConfirmButton: true
            });
        },
    },
};
</script>

<style scoped src="./mainPage.scss" lang="scss"></style>
